module.exports = __webpack_public_path__ + "img/AL803-2.89745d0a.jpg";